export interface WaybillCommentsModel {
  id: number;
  fullName: string;
  createdAt: number;
  comment: string;
}
